export const order_ruleset1_PD_GV  = 'bestrank.rank is not null DESC, PN, label';
